import React, { Component, useContext } from 'react';
import { ContentDiv, BodyHeaderDiv, BodyHeaderText } from '../../theme/MorsTheme';
import { Col, Form, Modal } from 'react-bootstrap';
import { allDays, } from '../../Utilities/DatePicker';
import { getTaxReportRequestLogs, printCwtCsv } from '../../Utilities/WSUtil';
import Period from '../../components/forms/Period';
import TaxReprintList from '../ReportFiles/TaxReprintList';
import Loader from '../../components/ui/Loader';
export default class SearchTaxReprint extends Component {

    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.updateToAllDays = this.updateToAllDays.bind(this);
        this.updateFromAllDays = this.updateFromAllDays.bind(this);
        this.onToggleMode = this.onToggleMode.bind(this);
        this.back = this.back.bind(this);
        this.onSuccess = this.onSuccess.bind(this);
        this.onFailed = this.onFailed.bind(this);
        this.printCsv = this.printCsv.bind(this);

        this.state = {
            checkedAllReport: false,
            searchSingleId: '',
            btnShow: false,
            fetchMessage: '',
            loading: false,
            names: [],
            toAllDays: allDays,
            fromAllDays: allDays,
            mode: 'M',
            enablePrint: false,
            enableView: false,
            monthlySelected: true,
            mid: null,
            taxReprintList: [],
            listLoaded: false,
            enableFinished: false,
            csvFilename: null
        };
    }
    loadReprintList() {
        var periodSchedFrom = document.getElementById('periodSchedFrom').value;
        var periodYearFrom = document.getElementById('periodYearFrom').value;

        var periodSchedTo = document.getElementById('periodSchedTo').value;
        var periodYearTo = document.getElementById('periodYearTo').value;

        var param = {
            mid: this.state.mid,
            fromYear: periodYearFrom,
            toYear: periodYearTo,
            fromPeriod: periodSchedFrom,
            toPeriod: periodSchedTo,
            schedule: this.state.mode
        };

        const csvFilename = `${this.state.mid}_${param.fromYear}-${param.fromPeriod}_${param.toYear}-${param.toPeriod}_${this.state.mode}.csv`;

        // this.props.getCwtReprintParam(param);
        this.setState({ loading: true, csvFilename })
        getTaxReportRequestLogs(param).then(response => {
            // this.setState({ loading: false })
            // this.props.getTaxReportRequestLog(result);
            // this.props.history.push("/taxReprintList");
            var enablePrint = false;
            if (response.length > 0) {
                enablePrint = true;
            }
            this.setState({ taxReprintList: response, listLoaded: true, loading: false, enablePrint: enablePrint });
        }).catch(() => {
            this.setState({ loading: false })
        })
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        // this.setState({ loading: true })
        this.loadReprintList();
    }

    handleChange(event) {
        const mid = event.target.value;
        if (mid) {
            this.setState({ mid: mid, enableView: true });
        } else {
            this.setState({ mid: mid, enableView: false });
        }
    }
    //Monina start - added
    updateToAllDays(e) {
        var toYear = document.getElementById('toYear').value;
        var toMonth = document.getElementById('toMonth').value;
        var valYear = (typeof toYear !== 'undefined') ? toYear : 0;
        var valMonth = (typeof toMonth !== 'undefined') ? toMonth : 0;
        this.setState({
            [e.target.id]: e.target.value,
            toAllDays: this.updateAllDays(valYear, valMonth)
        });
    }

    updateFromAllDays(e) {
        var fromYear = document.getElementById('fromYear').value;
        var fromMonth = document.getElementById('fromMonth').value;
        var valYear = (typeof fromYear !== 'undefined') ? fromYear : 0;
        var valMonth = (typeof fromMonth !== 'undefined') ? fromMonth : 0;
        this.setState({
            [e.target.id]: e.target.value,
            fromAllDays: this.updateAllDays(valYear, valMonth)
        });
    }

    updateAllDays(year, month) {
        var selDate = new Date(year, month, 0);
        var arrResult = [];
        Array.from(Array(selDate.getDate())).map((e, i) => i + 1).forEach(function (value, idx) {
            arrResult[idx + 1] = value;
        });
        return arrResult;
    }
    onToggleMode(event, mode) {
        // const mode = event.target.checked ? 'Q' : 'M';
        if (event.target.checked) {
            const monthlySelected = mode == 'M' ? true : false;
            this.setState({ mode, monthlySelected });
        }

    }

    back() {
        this.setState({ listLoaded: false, enablePrint: false, taxReprintList: [] });
    }
    onSuccess() {
        this.loadReprintList();
    }



    printCsv() {


        // var data = JSON.stringify(this.state.taxReprintList);
        const header = 'CWT,MID,CWT DATE,NO OF REQUEST,LAST PRINTED BY,DATE PRINTED,PROCESSED BY, DATE PROCESSED\n';
        var data = this.state.taxReprintList.reduce((accumulator, currentValue, index) => {
            const objectString = `${currentValue.cwt},${currentValue.mid},${currentValue.cwtDate},${currentValue.numberOfRequest},${currentValue.lastPrintedBy},${currentValue.datePrinted},${currentValue.processedBy ? currentValue.processedBy : ''},${currentValue.dateProcessed ? currentValue.dateProcessed : ''}`;

            if (index > 0) {
                return accumulator + '\n' + objectString;
            } else {
                return objectString;
            }
        }, '');

        const csvData = header + data;

        printCwtCsv({ data: csvData })
            .then(() => { }) // do nothing, just call
            .catch(() => { });

        const element = document.createElement("a");
        const file = new Blob([csvData], { type: 'text/plain' });
        element.style.visibility = 'hidden';
        element.href = URL.createObjectURL(file);
        element.download = this.state.csvFilename;
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
        document.body.removeChild(element);
    }

    onFailed() {

    }

    renderTable() {
        if (this.state.listLoaded) {
            return (<TaxReprintList items={this.state.taxReprintList}
                back={this.back}
                onSuccess={this.onSuccess}
                onFailed={this.onFailed} />);
        }
        return null;
    }
    renderViewButton() {
        if (!this.state.listLoaded) {
            return (
                <div align="center">
                    <button className="submit-btn" disabled={!this.state.enableView} onClick={this.handleSubmit}>View</button>
                </div>
            );
        }
        return (<></>);
    }
    render() {
        return (
            <div>
                <BodyHeaderDiv>
                    <BodyHeaderText>CWT/BIR 2307 REPRINT REQUEST</BodyHeaderText>
                </BodyHeaderDiv>
                <ContentDiv>
                    {/* <Form> */}
                    <div className="print-csv-btn">
                        <button className="submit-btn" disabled={!this.state.enablePrint} onClick={this.printCsv}>PRINT CSV</button>
                    </div>
                    <div >
                        <div className="rd-btn-group">
                            <span>
                                <input type="radio" id="sched-m" name="sched" checked={this.state.monthlySelected} onChange={(event) => this.onToggleMode(event, 'M')} disabled={this.state.listLoaded} />
                                <label>Monthly</label>
                            </span>
                            <span>
                                <input type="radio" id="ched-q" name="sched" onChange={(event) => this.onToggleMode(event, 'Q')} disabled={this.state.listLoaded} />
                                <label>Quarterly</label>
                            </span>
                        </div>

                    </div>
                    {/* <div className="cwt-mid-search">
                            <span className="cwt-mid-lbl" >MID</span>
                            <span><input type="text"></input></span>

                        </div> */}
                    <Form.Row>
                        <Col sm={2} md={2}>
                            <Form.Label size='sm' style={{ fontWeight: 'bold' }}>MID</Form.Label>

                        </Col>
                        <Col>
                            <Form.Group as={Col} sm={12} controlId="searchSingleId" onChange={this.handleChange}>
                                <Form.Control maxLength={10} size='sm' type="text" disabled={this.state.listLoaded}></Form.Control>
                            </Form.Group>
                        </Col>

                    </Form.Row>
                    <Period mode={this.state.mode} disabled={this.state.listLoaded} />
                    {this.renderViewButton()}

                    {/* </Form> */}
                    {this.renderTable()}
                </ContentDiv>
                <Modal show={this.state.loading} backdrop={'static'} centered={true} backdropClassName='fade' dialogClassName="modal-bdox">
                    <div>
                        {/* <OverlayLoader
                            color={'#0B2972'}
                            loader="ClipLoader"
                            text="Loading..."
                            active={true}
                            backGroundColor={'black'}
                            opacity=".9">
                        </OverlayLoader> */}
                        <Loader text="Loading ..."></Loader>
                    </div>
                </Modal>
            </div>
        )
    }
}